import { Injectable } from '@angular/core';
import { Subject, BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NetworkErrorService {
  private _showTimeoutBanner = new BehaviorSubject<boolean>(false);
  public showTimeoutBanner$ = this._showTimeoutBanner.asObservable();

  private _showGenericError = new BehaviorSubject<boolean>(false);
  public showGenericError$ = this._showGenericError.asObservable();

  private _retry = new Subject<void>();
  public retry$ = this._retry.asObservable();

  constructor() { }

  showTimeoutError() {
    this._showTimeoutBanner.next(true);
  }

  hideTimeoutError() {
    this._showTimeoutBanner.next(false);
  }

  triggerRetry() {
    this._retry.next();
    this.hideTimeoutError();
  }

  showGenericError() {
    this._showGenericError.next(true);
  }

  hideGenericError() {
    this._showGenericError.next(false);
  }
}
